export enum EStatusProposta {
  PROPOSTA_EM_PROCESSAMENTO = "PROPOSTA_EM_PROCESSAMENTO",
  PROPOSTA_EM_ANALISE = "PROPOSTA_EM_ANALISE",
  PROPOSTA_RECUSADA = "PROPOSTA_RECUSADA",
  PROPOSTA_APROVADA = "PROPOSTA_APROVADA",
  PROPOSTA_EXCLUIDA = "PROPOSTA_EXCLUIDA",
  PROPOSTA_NAO_EFETIVADA = "PROPOSTA_NAO_EFETIVADA",
  APOLICE_EMITIDA = "APOLICE_EMITIDA",
}
